export const MENU_ITEMS = [
  {
    id: "manifest_xml",
    header: "Manifest",
    countable: false,
  },
  {
    id: "activities",
    header: "Activities",
    countable: true,
  },
  {
    id: "administrator_receivers",
    header: "Administrator Receivers",
    countable: true,
  },
  {
    id: "accesibility_services",
    header: "Accessibility Services",
    countable: true,
  },
  //   {
  //     id: "keys",
  //     header: "Keys",
  //     countable: true,
  //   },
  {
    id: "files",
    header: "Files",
    countable: true,
  },
];
